import { FC } from 'react'
import cx from 'classnames'

import { ModalProps } from '../Modal'
import { AdsAlertFormProps } from '../../forms/AdsAlertForm'

import * as SC from './styled'

export type AdsFormAlertModalProps = ModalProps & {
  className?: string
  form: AdsAlertFormProps
}

const AdsFormAlertModal: FC<AdsFormAlertModalProps> = ({
  className,
  form,
  ...modal
}) => {
  return (
    <SC.ModalStyled className={cx('AdsFormAlertModal', className)} {...modal}>
      <SC.Form {...form} />
    </SC.ModalStyled>
  )
}

export default AdsFormAlertModal
